import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { SolutionIntro } from './components/SolutionIntro';
import { TomosAccordion } from './components/TomosAccordion';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
export function App() {
  return <div className="min-h-screen bg-brand-black font-body selection:bg-brand-green selection:text-brand-black" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <PurchasePopup data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <PainPoints data-id="element-5" />
        <SolutionIntro data-id="element-6" />
        <TomosAccordion data-id="element-7" />
        <Bonuses data-id="element-8" />
        <Testimonials data-id="element-9" />
        <Pricing data-id="element-10" />
      </main>

      <footer className="bg-brand-black py-8 text-center border-t border-white/10" data-id="element-11">
        <p className="font-body text-gray-500 text-sm" data-id="element-12">
          © {new Date().getFullYear()} Padel Zurdo Pro. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}